import * as React from "react";
import { Route, Switch } from "react-router";

import { CandidateContainer } from "./details/candidateContainer";
import { CandidatesContainer } from "./search/candidatesContainer";

export const CandidatesFeature = () => (
    <Switch>
        <Route
            path="/candidates/:jobId/:leadId"
            exact
            component={CandidateContainer}
        />
        <Route path="/candidates" exact component={CandidatesContainer} />
    </Switch>
);
